package com.example.hukakmp.data

import com.example.hukakmp.model.EspecieConEstado
import com.example.hukakmp.model.EspecieDescubierta
import com.example.hukakmp.model.EstadisticasPescadex
import com.example.hukakmp.model.PescadexUsuario
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.firestore.Timestamp
import dev.gitlive.firebase.firestore.firestore

private const val PESCADEX_COLLECTION = "pescadex_usuarios"

class PescadexRepository {
    private val firestore = Firebase.firestore

    suspend fun obtenerPescadexUsuario(): PescadexUsuario {
        val uid = Firebase.auth.currentUser?.uid ?: return PescadexUsuario()
        return try {
            val document = firestore.document("$PESCADEX_COLLECTION/$uid").get()
            if (!document.exists) {
                PescadexUsuario(
                    deviceId = uid,
                    fechaInicio = Timestamp.now(),
                    ultimaActividad = Timestamp.now(),
                )
            } else {
                document.data<PescadexUsuario>()
            }
        } catch (_: Exception) {
            PescadexUsuario(deviceId = uid)
        }
    }

    suspend fun obtenerEspeciesConEstado(): List<EspecieConEstado> {
        val pescadex = obtenerPescadexUsuario()
        return PescadexCatalog.species.map { info ->
            val captura = pescadex.especiesDescubiertas[info.id]
            EspecieConEstado(
                info = info,
                esCapturada = captura != null,
                datosCaptura = captura,
            )
        }
    }

    suspend fun obtenerEstadisticas(): EstadisticasPescadex {
        val pescadex = obtenerPescadexUsuario()
        return EstadisticasPescadex(
            especiesDescubiertas = pescadex.especiesDescubiertas.size,
            totalEspecies = PescadexCatalog.species.size,
            totalCapturas = pescadex.especiesDescubiertas.values.sumOf { it.totalCapturas },
        )
    }

    suspend fun registrarEspeciesDeParte(
        especies: List<Pair<String, Int>>,
        locacion: String?,
        fechaParte: String?,
    ) {
        val uid = Firebase.auth.currentUser?.uid ?: return
        if (especies.isEmpty()) return

        val actual = obtenerPescadexUsuario()
        val mapa = actual.especiesDescubiertas.toMutableMap()

        especies
            .groupBy { PescadexCatalog.normalizeSpeciesId(it.first) }
            .forEach { (_, grupo) ->
                val nombre = grupo.first().first
                val cantidad = grupo.sumOf { it.second }.coerceAtLeast(1)
                val id = PescadexCatalog.findId(nombre) ?: return@forEach
                val info = PescadexCatalog.byId[id] ?: return@forEach
                val existente = mapa[id]
                val superaMejorDia = existente == null || cantidad >= existente.mejorDiaCantidad

                mapa[id] = if (existente == null) {
                    EspecieDescubierta(
                        especieId = id,
                        nombreComun = info.nombreComun,
                        nombreCientifico = info.nombreCientifico,
                        fechaDescubrimiento = Timestamp.now(),
                        totalCapturas = cantidad,
                        locaciones = listOfNotNull(locacion?.takeIf { it.isNotBlank() }),
                        rareza = info.rareza,
                        mejorDiaFecha = fechaParte,
                        mejorDiaCantidad = cantidad,
                    )
                } else {
                    existente.copy(
                        totalCapturas = existente.totalCapturas + cantidad,
                        locaciones = (existente.locaciones + listOfNotNull(locacion?.takeIf { it.isNotBlank() })).distinct(),
                        mejorDiaFecha = if (superaMejorDia) fechaParte else existente.mejorDiaFecha,
                        mejorDiaCantidad = if (superaMejorDia) cantidad else existente.mejorDiaCantidad,
                    )
                }
            }

        val actualizado = actual.copy(
            deviceId = uid,
            especiesDescubiertas = mapa,
            fechaInicio = actual.fechaInicio ?: Timestamp.now(),
            ultimaActividad = Timestamp.now(),
        )

        firestore.document("$PESCADEX_COLLECTION/$uid").set(actualizado, merge = true)
    }
}
